
























































import { Component, Prop, Vue } from "vue-property-decorator";
import { BookingRequest, Customer, ShopAggregations } from "../../api/types";
import SbModal from "@/components/Modal.vue";
import SbSpinner from "@/components/Spinner.vue";
import { createBookingRequest, getBookingsAvailability } from "@/api/bookings";

@Component({
  components: {
    SbModal,
    SbSpinner
  }
})
export default class ShopMenuConfirmModal extends Vue {
  @Prop({ default: false }) private open!: boolean;
  @Prop() private bookingRequest!: BookingRequest;
  @Prop() private shopAggregations!: ShopAggregations;
  @Prop() private showAddressField!: boolean;

  private customer: Customer = {
    name: "",
    emailAddress: "",
    phoneNumber: "",
    shortAddress: ""
  };
  private isSubmitting = false;

  async submit(customer: Customer) {
    this.isSubmitting = true;

    if (this.bookingRequest.resourceId == "Any") {
      this.bookingRequest.resourceId = await this.allocateResource(this.shopAggregations, this.bookingRequest);
    }

    const bookingRequest = {
      ...this.bookingRequest,
      customer
    };

    try {
      const { bookingId, stripeCustomerId } = await createBookingRequest(bookingRequest);
      if (!stripeCustomerId) {
        this.$router.push(`/booking-confirmation/${bookingId}`);
      }
    } catch (e) {
      console.error(e);
      this.$toast.error(e.message);
      this.isSubmitting = false;
    }
  }

  cancel() {
    if (this.isSubmitting) return;
    this.$emit("cancel");
    this.close();
  }

  close() {
    this.$emit("update:open", false);
  }

  private async allocateResource(shopAgg: ShopAggregations, booking: BookingRequest) {
    const { services } = shopAgg;
    const service = services[booking.serviceId];
    const resources = service.resources;
    const arr = [];
    ShopMenuConfirmModal.shuffle(resources);
    for (const resource of resources) {
      const availableBookings = await getBookingsAvailability(resource, booking.serviceId);
      if (
        ShopMenuConfirmModal.slotsDefined(availableBookings, booking.startDate)
      ) {
        if (availableBookings[booking.startDate].includes(booking.startTime)) {
          return resource;
        }
      }
    }
    return "Different";
  }

  private static slotsDefined(availableBookings: any, startDate: string) {
    return (
      availableBookings !== null &&
      availableBookings[startDate] !== undefined
    );
  }

  private static rand(n: number) {
    return Math.floor(Math.random() * n);
  }

  private static swap(t: any [], i: number, j: number) {
    const q = t[i];
    t[i] = t[j];
    t[j] = q;
    return t;
  }

  private static shuffle(resources: string []) {
    {
      let last = resources.length;
      let n;
      while (last > 0) {
        n = ShopMenuConfirmModal.rand(last);
        ShopMenuConfirmModal.swap(resources, n, --last);
      }
    }
  }
}
